import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable, ReplaySubject } from 'rxjs';

import 'rxjs/add/operator/map';

import { Page } from './../pages/page';
import { AppConfig } from "../app-config.service";

@Injectable()
export class PagesService {

    constructor(private http:Http) {

    }


    getPage(slug):Observable<Page> {
        return this.http
            .get(AppConfig.baseUrl + 'wp/v2/pages?slug=' + slug)
            .map((res:Response) => {
                return res.json();
            });
    }

    getAuthor(id:number) {
        return this.http
            .get(AppConfig.baseUrl + 'wp/v2/users/' + id)
            .map((res:Response) => {
                return res.json();
            });
    }


    getMediaObjects():Observable<any> {
        return this.http
            .get(AppConfig.baseUrl + 'wp/v2/media')
            .map((res:Response) => {
                return res.json();
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/pages.service.ts